import React from "react";
import { useSelector } from "react-redux";

import { useCompanySettings } from "../../hooks/useCompanySettings";
import EndValueCard from "../EndValueCard/EndValueCard";
import InitialinvestmentCard from "../InitialinvestmentCard/InitialinvestmentCard";
import { DownloadExcelButton } from "../DownloadControl";
import AmountInvestedChart from "../AmountInvestedChart/AmountInvestedChart";
import { shareDataSelector } from "../../store/slice/trade";
import { useAmountInvested } from "../../hooks/useTrades";
import { classNames } from "../../utils";

export default function AmountInvestedResult({ className }) {
  const companySettings = useCompanySettings();
  const shareData = useSelector(shareDataSelector);
  const [{ amountInvested }] = useAmountInvested();

  if (Object.keys(amountInvested).length === 0) return null;

  return (
    <div className={classNames("AmountInvestedResult", className)}>
      {!companySettings.hideChart && !!shareData.datas?.length && <AmountInvestedChart />}
      <div className="AmountInvestedResult__cards">
        <InitialinvestmentCard />
        <EndValueCard />
        <DownloadExcelButton />
      </div>
    </div>
  );
}
